import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const createBrandLite = ({ data }) => axios.post('/lite/brands', data);
